import { Car, Timestamp } from 'src/types'

export function transformDataCarDates(car: Car<Timestamp>): Car<Date> {
  const convertTimestampToDate = (timestamp?: Timestamp): Date | undefined => {
    if (!timestamp) return undefined

    return new Date(timestamp.seconds * 1000 + timestamp.nanoseconds / 1e6)
  }

  return {
    ...car,
    lastServiceDate: convertTimestampToDate(car.lastServiceDate),
    nextMaintenance: convertTimestampToDate(car.nextMaintenance),
  }
}
